import { useAuth } from '@/components/providers/preauth/AuthProvider';
import { URLS } from '@/utils/constants';
import { useRouter } from 'next/router';
import { FC, PropsWithChildren } from 'react';
import { AppTopNavigationBar } from '../molecules';

const LayoutTemplate: FC<PropsWithChildren> = ({ children }) => {
  const { signOut: logout } = useAuth();
  const router = useRouter();
  return (
    <div className="flex flex-col w-full gap-md">
      <AppTopNavigationBar
        logout={logout}
        goToHomePage={() => router.replace(URLS.home)}
      />
      {children}
    </div>
  );
};

export default LayoutTemplate;
